export enum StatusUser {
  waiting_confirm_registration = 0,
  waiting_approval = 1,
  active = 2,
  rejected = 3,
  inactive = 4
}
